import { TFunction } from "i18next";
import { TempFilePasswordManagementTableSortColumn } from "node-library/dist/paginations";

export function getTempFilePasswordSortString(
	sortColumn: TempFilePasswordManagementTableSortColumn,
	translation: TFunction<"translation", undefined>
): string {
	switch (sortColumn) {
		case TempFilePasswordManagementTableSortColumn.INSERTED:
			return translation("CreatedTime");

		case TempFilePasswordManagementTableSortColumn.NAME:
			return translation("Name");
		case TempFilePasswordManagementTableSortColumn.LAST_UPDATED:
			return translation("LastUpdated");
	}
}

export function generateStrongPassword(length: number = 12): string {
	const charset =
		"abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*()-_=+[]{}|;:,.<>?";
	let password = "";
	const array = new Uint32Array(length);
	window.crypto.getRandomValues(array); // cryptographically secure
	for (let i = 0; i < length; i++) {
		password += charset[array[i] % charset.length];
	}
	return password;
}
